import React, { useState } from "react";
import styles from "./Filters.module.scss";
import FilterCheckbox from "../../../UI/Checkbox/FilterCheckbox/FilterCheckbox";
import filtersData from "./filtersData.json";

const Filters: React.FC = () => {
  const [showAllFilters, setShowAllFilters] = useState({
    view: false,
    compound: false,
    density: false,
    rigidity: false,
    surface: false,
    picture: false,
    specify: false,
    color: false,
  });

  const getVisibleFilters = <T extends { id: number; labelText: string }>(filters: T[], key: keyof typeof showAllFilters) => {
    return showAllFilters[key] ? filters : filters.slice(0, 4);
  };

  const handleViewAllClick = (filterType: keyof typeof showAllFilters) => {
    setShowAllFilters((prev) => ({
      ...prev,
      [filterType]: !prev[filterType],
    }));
  };

  return (
    <div className={styles.left}>
      <div className={`${styles.price} ${styles.item}`}>
        <h3>Цена</h3>
        <div className={styles.inputs}>
          <p>От</p>
          <input type="text" />
          <p>До</p>
          <input type="text" />
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>По виду</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.viewFilters, "view").map((item) => (
              <FilterCheckbox key={`view-${item.id}`} labelText={item.labelText} id={`view-${item.identificator}-${item.id}`} />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("view")} className={styles.viewAll}>
            {showAllFilters.view ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>По составу</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.compoundFilters, "compound").map((item) => (
              <FilterCheckbox
                key={`compound-${item.id}`}
                labelText={item.labelText}
                id={`compound-${item.identificator}-${item.id}`}
              />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("compound")} className={styles.viewAll}>
            {showAllFilters.compound ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>По плотности</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.densityFilters, "density").map((item) => (
              <FilterCheckbox
                key={`density-${item.id}`}
                labelText={item.labelText}
                id={`density-${item.identificator}-${item.id}`}
              />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("density")} className={styles.viewAll}>
            {showAllFilters.density ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>По жесткости</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.rigidityFilters, "rigidity").map((item) => (
              <FilterCheckbox
                key={`rigidity-${item.id}`}
                labelText={item.labelText}
                id={`rigidity-${item.identificator}-${item.id}`}
              />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("rigidity")} className={styles.viewAll}>
            {showAllFilters.rigidity ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>По поверхности</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.surfaceFilters, "surface").map((item) => (
              <FilterCheckbox
                key={`surface-${item.id}`}
                labelText={item.labelText}
                id={`surface-${item.identificator}-${item.id}`}
              />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("surface")} className={styles.viewAll}>
            {showAllFilters.surface ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>С рисунком</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.pictureFilters, "picture").map((item) => (
              <FilterCheckbox
                key={`picture-${item.id}`}
                labelText={item.labelText}
                id={`picture-${item.identificator}-${item.id}`}
              />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("picture")} className={styles.viewAll}>
            {showAllFilters.picture ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>Уточнить</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.specifyFilters, "specify").map((item) => (
              <FilterCheckbox
                key={`specify-${item.id}`}
                labelText={item.labelText}
                id={`specify-${item.identificator}-${item.id}`}
              />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("specify")} className={styles.viewAll}>
            {showAllFilters.specify ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
      <div className={`${styles.filterSection} ${styles.item}`}>
        <h3>По цвету</h3>
        <div className={styles.field}>
          <div className={styles.column}>
            {getVisibleFilters(filtersData.colorFilters, "color").map((item) => (
              <FilterCheckbox
                key={`color-${item.id}`}
                color={item.color}
                labelText={item.labelText}
                id={`color-${item.identificator}-${item.id}`}
              />
            ))}
          </div>
          <p onClick={() => handleViewAllClick("color")} className={styles.viewAll}>
            {showAllFilters.color ? "Скрыть все" : "Посмотреть все"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Filters;
